"use strict";

(function () {
  function handleQuickViewClick(event) {
    const button = event.target;
    const productHandle = button.getAttribute('data-product-handle');
    const sectionId = button.getAttribute('data-section-id');
    const placeholder = button.getAttribute('data-placeholder');
    const existingPopup = document.querySelector('.quick-view-popup');
    if (existingPopup) {
      const popupSection = existingPopup.querySelector('.quick-view-popup__section');
      openProductQuickView(productHandle, sectionId, popupSection, placeholder);
      return;
    }
    const popup = document.createElement('div');
    popup.classList.add('quick-view-popup');
    popup.innerHTML = `
            <div class="quick-view-popup__content">
                <div class="quick-view-popup__section"></div>
                <button type="button" class="quick-view__close-button close-popup">
                    <svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none">
                        <path d="M0.462895 1.49508C0.128161 1.15311 0.128162 0.598663 0.462896 0.256692C0.79763 -0.0852798 1.34034 -0.0852796 1.67507 0.256692L9.74895 8.50513C10.0837 8.84711 10.0837 9.40155 9.74895 9.74352C9.41421 10.0855 8.8715 10.0855 8.53677 9.74352L0.462895 1.49508Z" fill="currentColor"/>
                        <path d="M1.46323 9.74331C1.1285 10.0853 0.585785 10.0853 0.251051 9.74331C-0.0836836 9.40134 -0.0836835 8.84689 0.251051 8.50492L8.32492 0.256478C8.65966 -0.085493 9.20237 -0.0854927 9.5371 0.256479C9.87184 0.59845 9.87184 1.1529 9.5371 1.49487L1.46323 9.74331Z" fill="currentColor"/>
                    </svg>
                </button>
            </div>
            <div class="quick-view-popup__overlay-backdrop close-popup"></div>
        `;
    document.body.appendChild(popup);
    document.body.classList.add('body-hidden');
    const popupSection = popup.querySelector('.quick-view-popup__section');
    openProductQuickView(productHandle, sectionId, popupSection, placeholder);
    const closePopupButtons = popup.querySelectorAll('.close-popup');
    closePopupButtons.forEach(button => {
      button.addEventListener('click', () => {
        document.body.removeChild(popup);
        document.body.classList.remove('body-hidden');
      });
    });
    window.addEventListener('click', event => {
      if (event.target === popup) {
        document.body.removeChild(popup);
        document.body.classList.remove('body-hidden');
      }
    });
  }
  window.murmel = window.murmel || {};
  window.murmel.handleQuickViewClick = handleQuickViewClick;
  function openProductQuickView(productHandle, sectionId, targetElement, placeholder) {
    fetch(`/products/${productHandle}?section_id=quick-view`).then(res => res.text()).then(html => {
      targetElement.innerHTML = html;
      reimportScripts(targetElement);
      const placeholderImg = targetElement.querySelector('.placeholder-element');
      if (placeholderImg) {
        placeholderImg.setAttribute('src', placeholder);
      }
      const button = document.querySelector('.quick-view__close-button');
      if (button) {
        const parent = button.closest('.quick-view-popup__content');
        const initialOffset = 8;
        const updateButtonPosition = () => {
          const scrollY = parent.scrollTop;
          button.style.top = `${initialOffset + scrollY}px`;
        };
        parent.addEventListener('scroll', updateButtonPosition);
      }
      setTimeout(() => {
        const element = document.querySelector('.quick-view__product-description');
        if (element) {
          const elementHeight = element.offsetHeight;
          if (elementHeight > 96) {
            element.classList.add('collapsible');
          }
        }
      }, 0);
    }).catch(error => {
      console.error(error);
    });
  }
  function reimportScripts(node) {
    function nodeScriptClone(node) {
      const script = document.createElement("script");
      script.text = node.innerHTML;
      let i = -1;
      const attrs = node.attributes;
      while (++i < attrs.length) {
        script.setAttribute(attrs[i].name, attrs[i].value);
      }
      return script;
    }
    function nodeScriptIs(node) {
      return node.tagName === "SCRIPT";
    }
    if (nodeScriptIs(node)) {
      node.parentNode.replaceChild(nodeScriptClone(node), node);
    } else {
      let i = -1;
      const children = node.childNodes;
      while (++i < children.length) {
        reimportScripts(children[i]);
      }
    }
    return node;
  }
  function quickViewToggle() {
    const textContainer = document.querySelector('.quick-view__product-description');
    textContainer.classList.toggle('expanded');
  }
  window.murmel.quickViewToggle = quickViewToggle;
})();